export enum LoadingStatus {
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}
